export default __webpack_public_path__ + "static/media/JOSA CLASS-8 EXAM PATTERN 2025.7e809e11.pdf";